export default __webpack_public_path__ + "static/media/SafariDefault.7e340823.png";